import React from 'react';
import useStyle from './badgeAvatarSidebar.style';
import { Avatar } from '../../../atoms/Avatar';
import { classNames } from '../../../../helpers/style/classNames';
import { ROLE } from '../../../../helpers/user/authorization';
import { prettifyRole } from '../../../../helpers/user/prettifyRole';

interface BadgeAvatarSidebarViewProps {
  lienSource: string;
  pseudo: string;
  role: ROLE;
  onClick?: () => void;
  isMobile: boolean;
}

export const BadgeAvatarSidebarView = ({
  lienSource,
  pseudo,
  role,
  onClick,
  isMobile
}: BadgeAvatarSidebarViewProps) => {
  const classes = useStyle();

  return (
    <div
      onClick={onClick}
      className={classNames([classes.root], {
        condition: isMobile,
        classe: classes.mobile
      })}
    >
      <Avatar alt={pseudo} source={lienSource} variant={'leaderboard'} />
      <div>
        <p className={`${isMobile ? classes.pseudoMobile : classes.pseudo}`}>
          {pseudo}
        </p>
        <p className={classes.role}>{prettifyRole(role)}</p>
      </div>
    </div>
  );
};
